import { render, staticRenderFns } from "./ExpressLayover.vue?vue&type=template&id=6e048856&scoped=true"
import script from "./ExpressLayover.vue?vue&type=script&lang=js"
export * from "./ExpressLayover.vue?vue&type=script&lang=js"
import style0 from "./ExpressLayover.vue?vue&type=style&index=0&id=6e048856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e048856",
  null
  
)

export default component.exports